// Chakra imports
import { SimpleGrid, Text, useColorModeValue } from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card.js";
import React from "react";
import Information from "views/admin/profile/components/Information";

// Assets
export default function GeneralInformation(props) {
  const { ...rest } = props;
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const cardShadow = useColorModeValue(
    "0px 18px 40px rgba(112, 144, 176, 0.12)",
    "unset"
  );
  return (
    <Card mb={{ base: "0px", "2xl": "20px" }} {...rest}>
      <Text
        color={textColorPrimary}
        fontWeight='bold'
        fontSize='2xl'
        mt='10px'
        mb='4px'>
        General Information
      </Text>
      <Text color={textColorSecondary} fontSize='md' me='26px' mb='40px'>
        Shashank is a Product Manager with background in computer engineering and cybersecurity. He has worked in various industries previously and is currently working with AIVRM Inc. to develop a new platform that aims to align the security team's priorities with those of CISOs and board members.
      </Text>
      <SimpleGrid columns='2' gap='20px'>
        <Information
          boxShadow={cardShadow}
          title='Education'
          value='University of California, Berkeley and University of Waterloo'
        />
        <Information
          boxShadow={cardShadow}
          title='Languages'
          value='English, French, Python, React, Node, Javascript, Java'
        />
        <Information
          boxShadow={cardShadow}
          title='Department'
          value='Product Manager'
        />
        <Information
          boxShadow={cardShadow}
          title='Work History'
          value='Cision, SAP, Flashfood, Telus'
        />
        <Information
          boxShadow={cardShadow}
          title='Organization'
          value='AIVRM Inc.'
        />
        <Information
          boxShadow={cardShadow}
          title='Birthday'
          value='January 1998'
        />
      </SimpleGrid>
    </Card>
  );
}
